import { Add, Edit } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { Chip, FormControl, InputLabel, MenuItem, Paper, Select, SwipeableDrawer, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import jwtAuthAxios from 'app/services/auth/jwtAuth';
import React, { useState, useEffect } from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import useSwalWrapper from '@jumbo/vendors/sweetalert2/hooks';
import TableSkeleton from 'app/shared/widgets/TableSkeleton';
import useJumboAuth from '@jumbo/hooks/useJumboAuth';

const validationSchema = yup.object({
  branchCode: yup.string().required('Branch code is required'),
  branchName: yup.string().required('Branch Name is required'),
  address: yup.string().required('Address is required'),
  company: yup.string().required('Company is required'),
  city: yup.string().required('City is required'),
  country: yup.string().required('Country is required'),
});

const AddBranch = () => {
  const [branchesData, setBranchesData] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [drawer, setDrawer] = useState(false);
  const [isedit, setIsedit] = useState(false);
  const [loading, setLoading] = useState(false);
  const {rights} = useJumboAuth()
  const swal = useSwalWrapper();

  const formik = useFormik({
    initialValues: {
      branchCode: '',
      branchName: '',
      address: '',
      company: '',
      city: '',
      country: '',
      FL_GST_NO: '',
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      // console.log(values)
      setLoading(true);
      const endpoint = isedit ? `branch/branches/${values.branchCode}` : 'branch/addbranch';
      try {
        const response = await jwtAuthAxios.post(endpoint, values);
        // console.log(response.data);
        if (response.data.status === "success") {
          fetchBranchData();
          setDrawer(false);
          swal.fire({
            icon: 'success',
            text: response.data.message,
          });
        } else {
          swal.fire({
            icon: 'error',
            text: response.data.message ||'Something Went Wrong',
          });
        }
      } catch (error) {
        console.error(error);
        swal.fire({
          icon: 'error',
          text: 'Something Went Wrong',
        });
      } finally {
        setLoading(false);
      }
    },
  });

  const fetchBranchData = async () => {
    try {
      const response = await jwtAuthAxios.get('branch');
      setBranchesData(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchCompanyData = async () => {
    try {
      const response = await jwtAuthAxios.get('company');
      setCompanies(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchCompanyData();
    fetchBranchData();
  }, []);
  useEffect(() => {
    if(drawer == false){
      formik.resetForm()
      setIsedit(false)
    }
  }, [drawer]);

  const branchEditHandler = (branch) => {
    formik.setValues({
      branchCode: branch?.FL_BRANCH_CODE || '',
      branchName: branch?.FL_BRANCH_NAME || '',
      address: branch?.FL_BRANCH_ADDR || '',
      company: branch?.FL_COMPANY_CODE || '',
      city: branch?.FL_BRANCH_CITY || '',
      country: branch?.FL_BRANCH_COUNTRY || '',
      FL_GST_NO: branch?.FL_GST_NO || '',
    });
    setIsedit(true);
    setDrawer(true);
  };

  return (
    <div>
      {rights?.insert==1&& <LoadingButton variant="contained" onClick={() => setDrawer(true)} sx={{ display: 'flex', margin: '0 0px 22px auto' }} startIcon={<Add />} color="primary">
        Add Branch
      </LoadingButton>}
      {branchesData.length > 0 ?
        <TableContainer component={Paper}>
          <Table size='small'>
            <TableHead>
              <TableRow>
                <TableCell>Branch code</TableCell>
                <TableCell>Branch Name</TableCell>
                <TableCell>GST No</TableCell>
                <TableCell>Address</TableCell>
                <TableCell>Company</TableCell>
                <TableCell>City</TableCell>
                <TableCell>Country</TableCell>
                <TableCell align='right'>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {branchesData.map((branch, index) => (
                <TableRow key={index}>
                  <TableCell>{branch.FL_BRANCH_CODE}</TableCell>
                  <TableCell>{branch.FL_BRANCH_NAME}</TableCell>
                  <TableCell>{branch?.FL_GST_NO}</TableCell>
                  <TableCell>{branch?.FL_BRANCH_ADDR}</TableCell>
                  <TableCell>{branch.FL_COMPANY_NAME}</TableCell>
                  <TableCell>{branch.FL_BRANCH_CITY}</TableCell>
                  <TableCell>{branch.FL_BRANCH_COUNTRY}</TableCell>
                  <TableCell align='right'>
                    {rights?.edit ==1 &&  <Chip
                      color={"error"}
                      onClick={() => branchEditHandler(branch)}
                      icon={<Edit fontSize='18px' />}
                      label="edit"
                    />}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer> :<TableSkeleton cols={7} />}
      <SwipeableDrawer
        anchor="right"
        open={drawer}
        onClose={() => setDrawer(false)}
        onOpen={() => setDrawer(true)}
      >
        <Box
          component="form"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            minWidth: '400px',
            margin: '0 auto',
            p: 3,
          }}
          onSubmit={formik.handleSubmit}
        >
          <h3 style={{ padding: '5px', marginTop: '0' }}>Branch</h3>
          <TextField
            label="Branch Code"
            variant="outlined"
            margin="normal"
            fullWidth
            disabled={isedit}
            autoFocus
            {...formik.getFieldProps('branchCode')}
            error={formik.touched.branchCode && Boolean(formik.errors.branchCode)}
            helperText={formik.touched.branchCode && formik.errors.branchCode}
          />
          <TextField
            label="Branch Name"
            variant="outlined"
            margin="normal"
            fullWidth
            {...formik.getFieldProps('branchName')}
            error={formik.touched.branchName && Boolean(formik.errors.branchName)}
            helperText={formik.touched.branchName && formik.errors.branchName}
          />
          <TextField
            label="Address"
            variant="outlined"
            margin="normal"
            fullWidth
            {...formik.getFieldProps('address')}
            error={formik.touched.address && Boolean(formik.errors.address)}
            helperText={formik.touched.address && formik.errors.address}
          />
          <FormControl variant="outlined" fullWidth margin="normal">
            <InputLabel id="company-label">Company</InputLabel>
            <Select
              labelId="company-label"
              label="Company"
              {...formik.getFieldProps('company')}
              error={formik.touched.company && Boolean(formik.errors.company)}
              helperText={formik.touched.company && formik.errors.company}
            >
              {companies.map((company) => (
                <MenuItem key={company?.FL_COMPANY_CODE} value={company?.FL_COMPANY_CODE}>
                  {company?.FL_COMPANY_NAME}
                </MenuItem>
              ))}
            </Select>
            {formik.touched.company && formik.errors.company && (
              <p className="MuiFormHelperText-root Mui-error MuiFormHelperText-sizeMedium MuiFormHelperText-contained css-1qhtpql-MuiFormHelperText-root">
                {formik.touched.company && formik.errors.company}
              </p>
            )}
          </FormControl>
          <TextField
            label="City"
            variant="outlined"
            margin="normal"
            fullWidth
            {...formik.getFieldProps('city')}
            error={formik.touched.city && Boolean(formik.errors.city)}
            helperText={formik.touched.city && formik.errors.city}
          />
          <TextField
            label="Country"
            variant="outlined"
            margin="normal"
            fullWidth
            {...formik.getFieldProps('country')}
            error={formik.touched.country && Boolean(formik.errors.country)}
            helperText={formik.touched.country && formik.errors.country}
          />
          <TextField
            label="GST Number"
            variant="outlined"
            margin="normal"
            fullWidth
            {...formik.getFieldProps('FL_GST_NO')}
            error={formik.touched.FL_GST_NO && Boolean(formik.errors.FL_GST_NO)}
            helperText={formik.touched.FL_GST_NO && formik.errors.FL_GST_NO}
          />

          <LoadingButton
            loading={loading}
            type="submit"
            variant="contained"
            color="primary"
            sx={{ marginTop: '16px' }}
          >
            Submit
          </LoadingButton>
        </Box>
      </SwipeableDrawer>
    </div>
  );
};
AddBranch.Modulename = 'Branch'

export default AddBranch;
